import React, { useEffect, useState } from "react";
import Search from "../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import svg27 from "../../../../../assets/svg/svg27.svg";
import svg12 from "../../../../../assets/svg/svg12.svg";
import svg15 from "../../../../../assets/svg/svg15.svg";
import svg13 from "../../../../../assets/svg/svg13.svg";
import BreadCrumb from "../../../../../layout/BreadCrumb";
import CardLoading from "../../../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../../../features/obj/objSlice";
import { formatText } from "../../../../../utils";
import ConfirmModal from "../../../../../components/ConfirmModal";
import MembersView from "./MembersView";
import useModalToggle from "../../../../../custom_hooks/useModalToggle";
import MembersAdd from "./MembersAdd";
import toast from "react-hot-toast";
import { save } from "../../../../../features/save/saveSlice";
import moment from "moment";

function MemberTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/irrPartMembers/fetch";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { activeObjPartners } = useSelector((state) => ({
    activeObjPartners: state.obj.activeObj["partners"],
  }));
  const { refetchKey } = useSelector((state) => state.global);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        fullName: e.target.value == "" ? null : e.target.value,
        start: 0,
        limit: null,
      })
    );
  };
  const { open, handleCancel, handleOpen } = useModalToggle();
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/irrPartMembers/delete",
        usrId: prodd?.usrId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false)
      await fetchMemberssData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => { 
    await handleOpen();
  };

  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "partnersMembers", data: prodd }));
    await showDrawer();
  };

  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg12} alt="svg12" className="w-4 h-4" />
            <span className="whitespace-nowrap">Edit</span>
          </Link>
          <div className="mt-4">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg15} alt="svg15" className="w-4 h-4" />
            <span className="whitespace-nowrap">View</span>
          </Link>
          <div className="mt-4">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg13} alt="svg13" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Member",
      dataIndex: "fullNames",
      sorter: (a, b) => a.fullNames.localeCompare(b.fullNames),
    },

    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },

    {
      title: "Date Created",
      dataIndex: "usrCreatedDate",
      render: (text) =>
        text ? moment(text).format("DD-MM-YYYY") : "--",
      sorter: (a, b) =>
        moment(a.usrCreatedDate).valueOf() - moment(b.usrCreatedDate).valueOf(),
    },
    {
      title: "Status",
      dataIndex: "usrStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          PENDING_APPROVAL: "#3250FF",
          INACTIVE: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchMemberssData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        irrigationPartnerId: activeObjPartners?.ipId,
      })
    );
  }
  useEffect(() => {
    if (refetchKey == 2) {
      fetchMemberssData();
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <div className="flex flex-col w-full   ">
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between   gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
          <div className="w-[200px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <span className="ml-1">Add Member</span>
            </button>
          </div>
        </div>

        <div className="dash-inner-page mt-[1rem] max-w-full w-full overflow-x-auto">
          <section>
            <Table
              rowSelection={false}
              className=" w-full"
              scroll={{
                x: 1200,
              }}
              rowKey={(record) => record?.usrId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchMemberssData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}
            />
          </section>
        </div>
      </div>
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />

      <MembersView onClose={onClose} open={openDrawer} />
      <MembersAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchMemberssData}
        prodd={prodd}
      />
    </div>
  );
}

export default MemberTable;
